import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { HelpdeskService } from 'src/app/services/delavci/helpdesk.service';
import { MainService } from 'src/app/services/delavci/main.service';
import { HelpersService } from 'src/app/services/shared/helpers.service';
import { WarehouseAppService } from 'src/app/services/warehouse-app.service';

@Component({
  selector: 'app-izbira-skladisca',
  templateUrl: './izbira-skladisca.component.html',
  styleUrls: ['./izbira-skladisca.component.css']
})

export class IzbiraSkladiscaComponent implements OnInit{
  @ViewChild('input') input: ElementRef<HTMLInputElement>;
  myControl = new FormControl();
  options: { id: number, code: string, value: string }[] = [];
  filteredOptions: { id: number, code: string, value: string }[] = [];
  
ngOnInit() {
  this.warehouseAppService.getWarehousesList("NET@A809D6D7_C708_4951_ADAD_B94E304DF77B")
    .subscribe({
      next: (data) => {
        // Assuming 'data' has a 'warehouses' property that is the array
        if (data.warehouses && Array.isArray(data.warehouses)) {
          this.options = data.warehouses.map(warehouse => ({
            id: warehouse.PART_ID,
            code: warehouse.PART_CODE,
            value: warehouse.PART_TITLESMALL
          }));
          this.filteredOptions = this.options.slice(); // Initialize filteredOptions with all options
        } else {
          console.error('Unexpected data structure:', data);
        }
      },
      error: (error) => {
        console.error('There was an error!', error);
      }
    });
}



  constructor(private mainService: MainService, private router: Router, private helpersService: HelpersService,
    private deviceService: DeviceDetectorService, private helpdeskService: HelpdeskService, private warehouseAppService: WarehouseAppService) {
    this.filteredOptions = this.options.slice();
  }

  filter(): void {
    const filterValue = this.input.nativeElement.value.toLowerCase();
    this.filteredOptions = this.options.filter(o => o.value.toLowerCase().includes(filterValue));
  }
  
  

  trackByFn(index: any, item: any): number {
    return item.id; // Use the unique id as the trackBy identifier
  }

  displayFn(warehouse: { id: number, code: string, value: string }): string {
    return warehouse ? `${warehouse.code} - ${warehouse.value} (ID: ${warehouse.id})` : '';
  }
  
  navigateToHome(): void {
    this.router.navigate(['/aplikacija-home']);
  }
  
}
